import { Star } from "lucide-react";

export function StarRating({ value, size = 16, className = "" }: { value: number; size?: number; className?: string }) {
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} role="img" aria-label={`${value} av 5`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          width={size}
          height={size}
          className={n <= Math.round(value) ? "fill-primary text-primary" : "text-border"}
        />
      ))}
    </div>
  );
}

export function StarInput({ value, onChange }: { value: number; onChange: (n: number) => void }) {
  return (
    <div className="inline-flex items-center gap-1" role="radiogroup" aria-label="Betyg">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          role="radio"
          aria-checked={value === n}
          aria-label={`${n} stjärnor`}
          onClick={() => onChange(n)}
          className="rounded-pill p-1 transition hover:bg-primary-soft"
        >
          <Star
            width={28}
            height={28}
            className={n <= value ? "fill-primary text-primary" : "text-border"}
          />
        </button>
      ))}
    </div>
  );
}
